import { BRAND_MESSAGING } from '../../constants/brandMessaging';

interface SignupBrandPanelProps {
  styles: Record<string, string>;
  showTrustDetails?: boolean;
}

export default function SignupBrandPanel({ styles, showTrustDetails = false }: SignupBrandPanelProps) {
  return (
    <div className={styles.leftPanel}>
      <img
        src={`${process.env.PUBLIC_URL}/images/brand/verdekai-linkedin-company-logo.png`}
        alt="VerdeKai Legal Terminal"
        className={styles.brandImage}
      />
      <div className={styles.brandContent}>
        <h1 className={styles.platformName}>VerdeKai Legal Terminal</h1>
        <h2 className={styles.welcome}>{BRAND_MESSAGING.login.heading}</h2>
        <p className={styles.trustMsg}>{BRAND_MESSAGING.login.subheading}</p>
        {showTrustDetails && (
          <>
            <div className={styles.statsRow}>
              {BRAND_MESSAGING.login.stats.map((stat) => (
                <div key={stat.label}>
                  <span className={styles.statValue}>{stat.value}</span>
                  <span className={styles.statLabel}>{stat.label}</span>
                </div>
              ))}
            </div>
            <ul className={styles.trustList}>
              {BRAND_MESSAGING.login.trustBullets.map((bullet) => (
                <li key={bullet}><span className={styles.trustBadge}></span> {bullet}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
